import ServicePage from "../Common/ServicePage";

// Fan Repair specific services
const fanRepairServices = [
  { 
    id: 1, 
    name: 'Ceiling Fan Repair', 
    provider: 'FanFix Professionals', 
    image: 'https://placehold.co/600x400?text=Ceiling+Fan', 
    rating: 4.8, 
    reviews: 900, 
    price: 350, 
    category: 'Ceiling Fan' 
  },
  { 
    id: 2, 
    name: 'Table Fan Repair', 
    provider: 'PortableFan Experts', 
    image: 'https://placehold.co/600x400?text=Table+Fan', 
    rating: 4.7, 
    reviews: 750, 
    price: 300, 
    category: 'Table Fan' 
  },
  { 
    id: 3, 
    name: 'Fan Installation Service', 
    provider: 'InstallPro Services', 
    image: 'https://placehold.co/600x400?text=Fan+Installation', 
    rating: 4.85, 
    reviews: 600, 
    price: 250, 
    category: 'Installation' 
  },
  { 
    id: 4, 
    name: 'Fan Speed Regulator Replacement', 
    provider: 'SpeedControl Specialists', 
    image: 'https://placehold.co/600x400?text=Speed+Regulator', 
    rating: 4.75, 
    reviews: 400, 
    price: 150, 
    category: 'Parts Replacement' 
  },
  { 
    id: 5, 
    name: 'Exhaust Fan Repair', 
    provider: 'Ventilation Experts', 
    image: 'https://placehold.co/600x400?text=Exhaust+Fan', 
    rating: 4.72, 
    reviews: 350, 
    price: 400, 
    category: 'Exhaust Fan' 
  },
  { 
    id: 6, 
    name: 'Wall Fan Repair', 
    provider: 'WallFan Solutions', 
    image: 'https://placehold.co/600x400?text=Wall+Fan', 
    rating: 4.68, 
    reviews: 280, 
    price: 320, 
    category: 'Wall Fan' 
  },
  { 
    id: 7, 
    name: 'Fan Motor Replacement', 
    provider: 'MotorTech Services', 
    image: 'https://placehold.co/600x400?text=Fan+Motor', 
    rating: 4.80, 
    reviews: 500, 
    price: 450, 
    category: 'Parts Replacement' 
  },
  { 
    id: 8, 
    name: 'Fan Capacitor Replacement', 
    provider: 'ElectroFan Professionals', 
    image: 'https://placehold.co/600x400?text=Capacitor', 
    rating: 4.78, 
    reviews: 420, 
    price: 200, 
    category: 'Parts Replacement' 
  },
  { 
    id: 9, 
    name: 'Fan Blade Replacement', 
    provider: 'BladeMasters', 
    image: 'https://placehold.co/600x400?text=Fan+Blades', 
    rating: 4.82, 
    reviews: 380, 
    price: 180, 
    category: 'Parts Replacement' 
  },
  { 
    id: 10, 
    name: 'Fan Remote Repair', 
    provider: 'RemoteFix Experts', 
    image: 'https://placehold.co/600x400?text=Fan+Remote', 
    rating: 4.70, 
    reviews: 320, 
    price: 120, 
    category: 'Remote Repair' 
  }
];

const fanRepairCategories = ['Ceiling Fan', 'Table Fan', 'Exhaust Fan', 'Wall Fan', 'Installation', 'Parts Replacement', 'Remote Repair'];

const packages = [
  { id: 1, title: "Ceiling Fan Repair", rating: "4.8 (900 reviews)", price: 350, originalPrice: 450, icon: "🌀" },
  { id: 2, title: "Table Fan Repair", rating: "4.7 (750 reviews)", price: 300, originalPrice: 400, icon: "💨" },
];

const miniServices = [
  { id: 101, title: "Fan Installation", price: 250, icon: "🔧" },
  { id: 102, title: "Fan Speed Regulator Replacement", price: 150, icon: "⚙️" },
];

export default function FanRepair() {
  return (
    <ServicePage
      serviceName="Fan Repair"
      packages={packages}
      miniServices={miniServices}
      customServices={fanRepairServices}
      customCategories={fanRepairCategories}
      isCustomService={true}
    />
  );
}